<template>
  <div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else class="px-3 board-header">
      <div class="col-12" style="padding: 0px;">
        <div class="pull-left text-left col-12">
          <h5>
            {{ this.$t('reports.categoriesEvolution.reportTitle') }}
          </h5>
        </div>
        <div class="col-12" style="display: flex; padding-right: 15px;">
          <div class="col-3">
            <b-form-group
              :label="`${this.$t('reports.categoriesEvolution.profileLabel')}:`"
              label-for="select-profile"
            >
              <b-select
                id="select-profile"
                v-model="selectedProfile"
                :options="optionsProfiles"
              ></b-select>
            </b-form-group>
          </div>
          <div class="col-3">
            <b-form-group
              :label="`${this.$t(
                'reports.categoriesEvolution.categoryLabel',
              )}:`"
              label-for="select-category"
            >
              <b-select
                id="select-category"
                v-model="selectedCategory"
                :options="optionsCategories"
              ></b-select>
            </b-form-group>
          </div>
          <div
            v-if="categoriesAnalysis"
            class="col-6"
            style="text-align: right;"
          >
            <div style="display: flex; float: right;">
              <b-form-radio-group
                id="type-radio-group"
                name="radio-calculation"
                :value="categoryOption"
                v-model="categoryOption"
              >
                <b-form-radio name="frequency-radio" value="true">
                  {{ this.$t('reports.categoriesEvolution.frequencyOption') }}
                </b-form-radio>
                <b-form-radio name="answer-radio" value="false">
                  {{ this.$t('reports.categoriesEvolution.normalOption') }}
                </b-form-radio>
              </b-form-radio-group>

              <font-awesome-icon
                id="category-option-info"
                :icon="['fas', 'info-circle']"
                style="font-size: 15px; color: #c1c1c1;"
              />
              <b-popover
                target="category-option-info"
                triggers="hover"
                placement="bottom"
              >
                <b>Categoria (base frequência)</b> - Cálculo: Categoria / Total
                de categorias.<br />
                <br />
                <b>Categoria (base respostas)</b> - Cálculo: Categoria / Total
                de respostas.
              </b-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" style="overflow: auto;">
        <div class="row mt-4 col-12">
          <b-table
            id="table-categories-evolution"
            striped
            :items="items"
            :fields="fields"
            sort-icon-left
          >
          </b-table>
        </div>
        <div class="row mt-4 col-12">
          <b-table
            id="table-categories-evolution-total"
            striped
            :items="itemsTotal"
            :fields="fields"
            thead-class="d-none"
            style="font-weight: bold;"
          >
          </b-table>
        </div>
      </div>
      <div class="col-12 mt-2 text-right">
        <a @click="exportToXLS" title="Exportar para XLS">
          <span class="xls">
            <i class="fas fa-file-excel"></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';
import loader from '@/components/atoms/loader';
import api from '../../../../services/api';
import XLSX from 'xlsx';

export default {
  name: 'IndexConsultants',
  components: {
    loader,
  },

  data: () => ({
    loading: false,
    userAuth: null,
    fields: [],
    items: [],
    itemsTotal: [],
    currentPage: 1,
    categoriesAnalysis: false,
    categoryOption: false,
    selectedProfile: 'all',
    optionsProfiles: [],
    selectedCategory: null,
    optionsCategories: [],
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.setData();
    },

    myActionId: function watchmyActionId() {
      this.setData();
    },

    myActionsIds: function watchmyActionsIds() {
      this.setData();
    },

    calendarDates: function watchCalendarDates() {
      this.setData();
    },

    myIh1: function watchMyIh1() {
      this.setData();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.setData();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.setData();
    },

    myIh2: function watchMyIh2() {
      this.setData();
    },

    myMetric: function watchMyMetric() {
      this.setData();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.setData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.setData();
    },
    categoryOption: function watchCategoryOption() {
      this.setData();
    },
    selectedProfile: function watchSelectedProfile() {
      this.setData();
    },
    selectedCategory: function watchSelectedCategory() {
      this.setData();
    },
  },

  methods: {
    async setData() {
      this.loading = true;
      this.items = [];
      this.itemsTotal = [];
      // this.optionsCategories = [];
      const response = await api.get('/reports/categories-evolution', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          frequencyOption: this.categoryOption,
          profile: this.selectedProfile,
          categoryId: this.selectedCategory,
        },
      });

      if (response && response.data.length > 0) {
        const tabHeader = response.data[0];
        this.fields = [];
        this.items = [];
        this.itemsTotal = [];
        if (!this.selectedCategory) {
          this.optionsCategories = [];
          this.optionsCategories.push({
            value: null,
            text: this.$t('reports.categoriesEvolution.selCategoryLabel'),
          });
        }
        this.fields.push({
          key: 'categoryName',
          label: 'Categoria/Subcategoria',
          sortable: true,
          class: 'categoryTh',
        });
        for (let i = 0; i < tabHeader.evolution.length; i += 1) {
          this.fields.push({
            key: tabHeader.evolution[i].date,
            label: tabHeader.evolution[i].date,
            class: 'text-right valueTh',
            sortable: true,
          });
        }
        let itemObj = {};
        for (let i = 0; i < response.data.length; i += 1) {
          itemObj = {};
          itemObj.categoryName = response.data[i].categoryName;
          if (!this.selectedCategory) {
            this.optionsCategories.push({
              value: response.data[i].idCategory,
              text: response.data[i].categoryName,
            });
          }
          for (let j = 0; j < response.data[i].evolution.length; j += 1) {
            if (i === 0) {
              itemObj[response.data[i].evolution[j].date] = response.data[i].evolution[j].qtd;
            } else {
              itemObj[response.data[i].evolution[j].date] = response.data[i].evolution[j].pct;
            }
          }
          if (i === 0) {
            this.itemsTotal.push(itemObj);
          } else {
            this.items.push(itemObj);
          }
        }
      }

      this.loading = false;
    },
    async getCustomCategoriesAnalysis() {
      try {
        const response = await api.get('/categories-analysis', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
        this.categoriesAnalysis = response.data.customCategoriesAnalysis;
        if (this.categoriesAnalysis) {
          this.categoryOption = true;
        }
      } catch (error) {
        window.console.log(error);
      }
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    exportToXLS() {
      const header = [];
      for (let i = 0; i < this.fields.length; i += 1) {
        header.push(this.fields[i].label);
      }

      const arr = JSON.parse(JSON.stringify(this.items));
      // const arr = this.items;
      for (let i = 0; i < arr.length; i += 1) {
        arr[i]['Categoria/Subcategoria'] = arr[i].categoryName;
        delete arr[i].categoryName;
      }

      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('categorias');
      const ws = XLSX.utils.json_to_sheet(arr, { header });

      // eslint-disable-next-line
      wb.Sheets['categorias'] = ws;
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'evolucao-categorias.xlsx');
      document.body.appendChild(link);
      link.click();
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.loading = true;
    if (this.myMetric.indexOf('nps') >= 0) {
      this.optionsProfiles = [
        {
          value: 'all',
          text: this.$t('reports.categoriesEvolution.selProfileLabel'),
        },
        {
          value: 'promoter',
          text: this.$t('reports.categoriesEvolution.promoterLabel'),
        },
        {
          value: 'neutral',
          text: this.$t('reports.categoriesEvolution.neutralLabel'),
        },
        {
          value: 'detractor',
          text: this.$t('reports.categoriesEvolution.detractorLabel'),
        },
      ];
    } else {
      this.optionsProfiles = [
        {
          value: 'all',
          text: this.$t('reports.categoriesEvolution.selProfileLabel'),
        },
        {
          value: 'promoter',
          text: '4-5',
        },
        {
          value: 'neutral',
          text: '3',
        },
        {
          value: 'detractor',
          text: '1-2',
        },
      ];
    }
    await this.getCustomCategoriesAnalysis();
    await this.setData();
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

@media (max-width: 1310px) {
  .summary {
    flex-direction: column;
  }
}
</style>
<style lang="scss">
.categoryTh {
  min-width: 200px !important;
}
.valueTh {
  min-width: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/categories-evolution/index.vue